import { Button, Modal, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { BIGrey } from "../../../assets/helpers";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

function ConfirmModal(props) {
  const {
    isOpen,
    onClose,
    onConfirm,
    title = "You will be clocked out of your current Job.",
    confirmButtonText = "Continue",
    isHelpModal = false
  } = props;

  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  const { BUTTON_OK, TEXT_GO_BACK } = ClientEnglishFallback?.ConfirmModal(
    multiLanguageData?.ConfirmModal || {}
  );

  return (
    <Modal
      open={isOpen}
      onClose={(e) => {
        onClose(e);
      }}>
      <div
        className="client-modal-responsive"
        style={{
          width: "auto"
        }}>
        {isHelpModal ? (
          <>
            <Typography mb={1} textAlign={"center"}>
              {title}
            </Typography>
            <Stack direction={"row"} justifyContent={"center"} spacing={1}>
              <Button
                sx={{
                  backgroundColor: selectedClientData?.AccentColor,
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "white",
                  textTransform: "none",
                  width: "150px"
                }}
                onClick={() => {
                  onClose();
                }}
                size={"small"}>
                {BUTTON_OK}
              </Button>
            </Stack>
          </>
        ) : (
          <>
            <Typography
              mb={1}
              sx={{
                color: BIGrey
              }}
              textAlign={"center"}>
              {title}
            </Typography>
            <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
              <Button
                sx={{
                  backgroundColor: "#e4e4e4",
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "black",
                  textTransform: "none"
                }}
                onClick={(e) => {
                  onClose(e);
                }}
                fullWidth
                size={"small"}>
                {TEXT_GO_BACK}
              </Button>
              <Button
                sx={{
                  backgroundColor: selectedClientData?.AccentColor,
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "white",
                  textTransform: "none"
                }}
                onClick={() => {
                  onConfirm();
                }}
                fullWidth
                size={"small"}>
                {confirmButtonText}
              </Button>
            </Stack>
          </>
        )}
      </div>
    </Modal>
  );
}

export default ConfirmModal;
